import React, { Component } from "react";
import { Button, Form, Icon, Table, Grid, Card, Dimmer } from "tabler-react";
import {
  Crud_Catalogos,
  Crud_error,
} from "../../../herramientas/Crud_Catalogos";
import ModalLay from "../../../components/ModalLay/ModalLay";
import { CuentasEspejoForm } from "./../../";


/**
 * Notificaciones
 */
import { NotificationManager } from "react-notifications";


class CuentaEspejo extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      accion: this.props.accion, //'nuevo'// modificar, nuevo
      CuentasEspejo: [],
      ClientesDisponibles: [],
      selectedRow: -1,
      hiddenModals: false,
      search: "",
      pagination: [],
      pagina: 1,
      pagesize: 10
    };
    this.colum = [];
    this.pagination = [];
    this.content = [];
    this.cuentasPagination = [];
  }
  
  componentDidMount = () => {
    if (this.state.accion !== "nuevo") {
      this.setState({ id: this.props.elementos.id });
      this.plataformasObject = this.props.elementos;
      this.getfuntion(
        "get",
        "",
        "",
        "cuentasEspejo/plataforma/" +
          this.props.elementos.id +
          "/pagina/0/total/" +
          this.state.pagesize,
        "cuentasEspejo"
      );
    } else {
    }
  };
  getfuntion = (
    metodo = "get",
    obj = [],
    id = "",
    catalogo = "cuentasEspejo",
    stateVar = "cuentasEspejo",
    hiddenModl = ""
  ) => {
    Crud_Catalogos(
      catalogo,
      "plataformas",
      metodo,
      id,
      obj,
      "",
      stateVar,
      hiddenModl,
      []
    )
      .then((returnVal) => {
        /**
         * filtro de variables
         */
        console.log(stateVar)    
        console.log("cuentasEspejo")    
        switch (metodo) {
          case "get":
            {
              if (stateVar === "cuentasEspejo") {      
                
                if (returnVal.content) {
                  
                  this.setState({ CuentasEspejo: returnVal.content });
                  this.paginacion(returnVal);
                  this.cuentasPagination = returnVal;
                }
              }
             
            }
            break;
          case "post":
            {
              if (stateVar === "cuentasEspejo") {
                if (returnVal.idCuentaEspejo) {
                  NotificationManager.info(
                    "Se ha agregado la cuenta Espejo al catalogo general( " +
                      returnVal.nombre +
                      " )",
                    "Nuevo"
                  );
                  let cuentasTem = this.state.CuentasEspejo;
                  cuentasTem.unshift(returnVal);
                  this.setState({ CuentasEspejo: cuentasTem });
                  
                }
              }
           
            }
            break;
          case "put":
            {
              if (stateVar === "cuentasEspejo") {
                
                if (returnVal.idCuentaEspejo) {
                  NotificationManager.info(
                    "Se han agregado las modificaciones de la cuentas Espejo al catalogo general( " +
                      returnVal.nombre +
                      " )",
                    "Modificación"
                  );
                  let cuentasTem = this.state.CuentasEspejo;
                  for (let item of cuentasTem) {
                    if (item.idCuentaEspejo == returnVal.idCuentaEspejo) {
                      item = returnVal;
                    }
                  }
                  this.setState({ CuentaEspejo: cuentasTem });
                  this.hiddenmodal();
                }
              }
            }
            break;
          case "delete":
            {
              if (returnVal) {
                let cuentasTem = this.state.CuentasEspejo;
                cuentasTem.map((item, index) => {
                  if (item.idCuentaEspejo == obj.idCuentaEspejo) {
                    cuentasTem.splice(index, 1);
                    this.setState({ CuentaEspejo: cuentasTem });
                  }
                });
                NotificationManager.info(
                  "Se a removido correctamente",
                  "Borrar"
                );
              } else {
                NotificationManager.error("No se ha podido borrar", "Borrar");
              }
             
            }
            break;
          default:
            break;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  hiddenmodal = () => {
    this.setState({ hiddenModals: !this.state.hiddenModals });
    this.setState({ metodo: "get" });
  };
  table_headers = () => {
    this.content = [];
    let cli = this.state.CuentasEspejo;
    if (cli) {
      if (cli[0]) {
        Object.keys(cli[0]).forEach((key) =>
          this.content.push({ content: key })
        );
        this.content.push({
          content: this.state.agregar ? "agregar" : "editar",
        });
        if (!this.state.agregar) {
          this.content.push({ content: "eliminar" });
        }
      }
    }
  }; //CMA DSV AIR & SEA SA DE CV_GROUPE SEB MEXICO S.A. DE C.V. SERVICIOS EMPRESARIALES ZIMAG SA DE CV	 SAN PEDRO BARRIENTOS  TLANEPANTLA EDO DE MEXICO 54010-5502
  paginacion = (pag) => {
    this.pagination = pag;
    this.pagination.content = [];
    this.setState({ pagination: this.pagination });
  };
  searching = (event) => {
    this.setState({ search: event.target.value });
    if (
      this.state.CuentasEspejo.filter((word) =>
        word.nombre.toUpperCase().includes(event.target.value.toUpperCase())
      ).sort().length == 0 &&
      !event.target.value.toUpperCase().includes("{")
    ) {
      this.paginarNombre(encodeURIComponent(event.target.value));
    }
  };

  paginarNombre = (nombre) => {
    console.log("nombre")
    //cliente/plataforma/2/cliente/3d/pagina/0/total/2
    
      this.getfuntion(
        "get",
        "",
        "",
        "cuentasEspejo/plataforma/" +
          this.props.elementos.id +
          "/pagina/0/total/" +
          1000 +
          "/nombre/" +
          nombre,
        "cuentasEspejo"
      );
    
  };

  cancelar = () => {
    this.setState({ search: "" });
    this.setState({ agregar: false });
    this.setState({ pagina: 1 });
    this.paginacion(this.clientesPafination);
  };
  _editCol = (elemento) => {
    this.colum.push(
      <Table.Col>
        <ModalLay
          tamanio={"90%"}
          title="Modificar"
          name={
            <Button pill size="sm" outline color="primary">
              <Icon name="edit" />
            </Button>
          }
          formulario={CuentasEspejoForm}
          datosForm={{
            accion: "modificar",
            plataforma: this.props.elementos,
            getfuntion: this.getfuntion,
            stor: this.props.stor,
            elementos: elemento,
          }}
        />
      </Table.Col>
    );
    this.colum.push(
      <Table.Col>
        <span data-toggle="tooltip" data-placement="top" title={"Remover"}>
          <Button
            pill
            size="sm"
            outline
            color="primary"
            onClick={() =>
              this.getfuntion(
                "delete",
                {
                  idCuentaEspejo: elemento.idCuentaEspejo,
                },
                elemento.idCuentaEspejo,
                "cuentasEspejo",
                "cuentasEspejo"
              )
            }
          >
            <Icon name="trash" />
          </Button>
        </span>
      </Table.Col>
    );
  };
 
  render() {
    return (
      <div>
        {/**
         *   Elementos de plataformas
         */}
        {this.state.accion === "modificar" ? (
          <div>
            <Grid.Row>
              <Grid.Col>
                {!this.state.agregar ? (
                  <Card
                    title="La plataforma esta configurada para las siguientes CUENTAS ESPEJO"
                    isCollapsible={false}
                    //isClosable
                    isCollapsed={false}
                    options={
                      <div>
                        <span
                          className="float-right ml-2"
                          data-toggle="tooltip"
                          data-placement="top"
                          title={"Nueva cuenta"}
                        >
                          
                          <ModalLay
                            tamanio={"70%"}
                            hiddenModal={this.state.hiddenModals}
                            Fclose={this.hiddenmodal}
                            title="Nuevo"
                            name={
                              <Button pill size="sm" outline color="primary">
                                <Icon name="plus" />
                              </Button>
                            }
                            formulario={CuentasEspejoForm}
                            datosForm={{
                              accion: "nuevo",
                              plataforma: this.props.elementos,
                              getfuntion: this.getfuntion,
                              stor: this.props.stor,
                            }}
                          />
                        </span>
                      
                        
                        <span className="float-right">
                          <Form.Input
                            className="mb-3"
                            icon="search"
                            placeholder="Buscar cuentas espejo..."
                            position="append"
                            value={this.state.search}
                            onChange={this.searching}
                            onKeyDown={this._searchingkey}
                          />
                        </span>
                      </div>
                    }
                    body={
                      <div>
                        {this.state.CuentasEspejo ? (
                          <Form.Group>
                            <Table
                              cards={true}
                              striped={true}
                              responsive={true}
                              className="table-vcenter"
                              {...this.table_headers()}
                              headerItems={this.content}
                            >
                              <Table.Body>
                                {this.state.CuentasEspejo.filter((word) =>
                                  word.nombre
                                    .toUpperCase()
                                    .includes(this.state.search.toUpperCase())
                                )
                                  .sort()
                                  .map((elemento, index) => (
                                    <Table.Row
                                      style={
                                        this.state.selectedRow === index
                                          ? {
                                              "background-color":
                                                "rgba(95, 231, 50, 0.30)",
                                            }
                                          : null
                                      }
                                      onClick={() => {
                                        this.setState({ selectedRow: index });
                                      }}
                                    >
                                      {(this.colum = [])}
                                      {
                                        (Object.keys(elemento).forEach(
                                          (key, index) => {
                                            this.colum.push(
                                              <Table.Col>
                                                {" "}
                                                {key === "idTarifarioSubasta" && elemento[key] ? elemento[key].localidad : elemento[key]}{" "}
                                              </Table.Col>
                                            );
                                          }
                                        ),
                                        this._editCol(elemento))
                                      }
                                    </Table.Row>
                                  ))}
                              </Table.Body>
                            </Table>
                          </Form.Group>
                        ) : null}
                        <div className="row">
                          <div className="col-4"></div>
                          <div className="col-4">
                            <nav aria-label="...">
                              <ul class="pagination">
                                <li className="page-item">
                                  <span
                                    class="page-link"
                                    onClick={() =>
                                      this.state.pagination
                                        ? this.state.pagination.number > 0
                                          ? this.paginar(
                                              this.state.pagination.number - 1
                                            )
                                          : null
                                        : null
                                    }
                                  >
                                    Anterior
                                  </span>
                                </li>
                                {this.getpaginationLinks()}
                                <li class="page-item">
                                  <a
                                    class="page-link"
                                    onClick={() =>
                                      this.state.pagination
                                        ? this.state.pagination.number <
                                          this.state.pagination.totalPages
                                          ? this.paginar(
                                              this.state.pagination.number + 1
                                            )
                                          : null
                                        : null
                                    }
                                  >
                                    Siguiente
                                  </a>
                                </li>
                                <li class="page-item">
                                  <h3>
                                    <div className="row">
                                      <div className="col-4 text-right">
                                        {" "}
                                        <Form.Input
                                          name="pag212"
                                          type="number"
                                          value={this.state.pagina}
                                          onKeyDown={this._buscar}
                                          onChange={this._pag}
                                        />{" "}
                                      </div>
                                      <div className="col-8 text-left">
                                        {" "}
                                        /
                                        {this.state.pagination
                                          ? this.state.pagination.totalPages
                                            ? this.state.pagination.totalPages
                                            : 1
                                          : 0}
                                        Páginas{" "}
                                      </div>
                                    </div>
                                  </h3>
                                </li>
                              </ul>
                            </nav>
                          </div>
                          <div className="col-2">
                            <div className="row">
                              <div className="col-6 text-right">
                                {" "}
                                Total por página{" "}
                              </div>
                              <div className="col-6">
                                {" "}
                                <Form.Input
                                  name="pagTotal"
                                  type="number"
                                  value={this.state.pagesize}
                                  onChange={this._pagesize}
                                  onKeyDown={this._changePagesize}
                                />{" "}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  />
                ) : (
                  null
                )}
              </Grid.Col>
            </Grid.Row>
          </div>
        ) : null}
      </div>
    );
  }
  //this.getfuntion("get", "", "", "cliente/plataforma/"+this.props.elementos.id+"/pagina/0/total/"+this.state.pagesize, "clientes");
  paginar = (pag) => {
    
      if (this.state.search.length > 0) {
        this.getfuntion(
          "get",
          "",
          "",
          "cuentasEspejo/plataforma/" +
            this.props.elementos.id +
            "/pagina/" +
            pag +
            "/total/" +
            this.state.pagesize +
            "/nombre/" +
            this.state.search,
          "cuentasEspejo"
        );
      } else {
        this.getfuntion(
          "get",
          "",
          "",
          "cuentasEspejo/plataforma/" +
            this.props.elementos.id +
            "/pagina/" +
            pag +
            "/total/" +
            this.state.pagesize,
          "cuentasEspejo"
        );
      }
      this.setState({ pagina: pag + 1 });
    
  };
  getpaginationLinks = () => {
    var links = [];
    var numberPag = this.pagination.number;
    if (this.pagination) {
      for (let i = numberPag; i < numberPag + 5; i++) {
        if (i === numberPag) {
          links.push(
            <li class="page-item active" aria-current="page">
              {" "}
              <span class="page-link">
                {" "}
                {i + 1} <span class="sr-only">(current)</span>{" "}
              </span>{" "}
            </li>
          );
        } else {
          if (i < this.pagination.totalPages) {
            links.push(
              <li class="page-item">
                <a class="page-link" onClick={() => this.paginar(i)}>
                  {i + 1}
                </a>
              </li>
            );
          }
        }
      }
    }
    return links;
  };
  _changePagesize = (e) => {
    if (e.key === "Enter") {
      this.paginar(0);
    }
  };
  _searchingkey = (e) => {
    if (e.key === "Enter") {
      if (e.target.value == 0) {
        this.paginar(0);
      }
    }
  };
  _pagesize = (e) => this.setState({ pagesize: e.target.value });
  _buscar = (e) => {
    if (e.key === "Enter") {
      if (this.pagination.totalPages) {
        this.paginar(e.target.value - 1);
      }
    }
  };
  _pag = (event) => {
    this.setState({
      pagina:
        event.target.value > this.pagination.totalPages
          ? this.pagination.totalPages
          : this.pagination.totalPages
          ? event.target.value
          : 1,
    });
  };
}

export default CuentaEspejo;
